// extracted by mini-css-extract-plugin
export default {"container":"AppDownloadRectangle_container__Wmc9J","text":"AppDownloadRectangle_text__JTBT1","downloadBtns":"AppDownloadRectangle_downloadBtns__dces8"};